import {
  Cancel,
  CheckCircle,
  Delete,
  Groups,
  PhoneAndroid,
  Security,
  SwitchAccount,
  ToggleOn,
  VpnKey,
} from '@mui/icons-material';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { Box, Typography } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useUserTableColumns = ({
  editItem,
  onShowRoles,
  onShowPermissions,
  changeActivationStateItem,
  changePasswordItem,
  changeBaseRoleItem,
  convertToAgentItem,
  onDeleteItem,
  apiRef,
  permissions: columnPermissions = {},
}) => {
  const {
    canEdit = false,
    canDelete = false,
    canChangePassword = false,
    canChangeBaseRole = false,
    canChangeStatus = false,
    canViewRoles = false,
    canViewPermissions = false,
    canSetAsAgent = false,
  } = columnPermissions;

  const canViewActions =
    canEdit ||
    canDelete ||
    canChangePassword ||
    canChangeBaseRole ||
    canChangeStatus ||
    canViewRoles ||
    canViewPermissions ||
    canSetAsAgent ||
    true;

  const columnsData = [
    {
      field: 'fullName',
      headerName: 'نام و نام خانوادگی',
      flex: 1,
      minWidth: 150,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return `${params.row.name} ${params.row.family}`;
      },
    },
    {
      field: 'mobile',
      headerName: 'شماره همراه',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.mobile;
      },
    },
    {
      field: 'role',
      headerName: 'نقش پایه',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.role;
      },
    },

    {
      field: 'activationState',
      headerName: 'وضعیت',
      flex: 1,
      minWidth: 150,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.activationState === 'فعال' ? (
          <Box display="flex" alignItems="center" gap={1}>
            <CheckCircle color="success" />
            <Typography variant="body1">فعال</Typography>
          </Box>
        ) : (
          <Box display="flex" alignItems="center" gap={1}>
            <Cancel color="error" />
            <Typography variant="body1">غیرفعال</Typography>
          </Box>
        );
      },
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 300,

            getActions: params => {
              const buttons = [
                canEdit
                  ? {
                      label: 'ویرایش',
                      Icon: ModeEditOutlineIcon,
                      onClick: editItem(params.row),
                      color: 'warning',
                    }
                  : null,
                canChangeStatus
                  ? {
                      label: 'تغییر وضعیت',
                      Icon: ToggleOn,
                      onClick: changeActivationStateItem(params.row),
                      color: 'info',
                    }
                  : null,
              ].filter(Boolean);

              return [
                buttons.length ? (
                  <TableActionButtons key={10} buttons={buttons} />
                ) : null,
                canViewPermissions ? (
                  <GridActionsCellItem
                    key={2}
                    icon={<Security />}
                    label="نمایش دسترسی‌ ها"
                    onClick={onShowPermissions(params.row)}
                    showInMenu
                  />
                ) : null,
                canViewRoles ? (
                  <GridActionsCellItem
                    key={3}
                    icon={<Groups />}
                    label="نمایش نقش‌ ها"
                    onClick={onShowRoles(params.row)}
                    showInMenu
                  />
                ) : null,
                canChangePassword ? (
                  <GridActionsCellItem
                    key={4}
                    icon={<VpnKey />}
                    label="تغییر رمز عبور"
                    onClick={changePasswordItem(params.row)}
                    showInMenu
                  />
                ) : null,
                canChangeBaseRole ? (
                  <GridActionsCellItem
                    key={5}
                    icon={<SwitchAccount />}
                    label="تغییر نقش پایه"
                    onClick={changeBaseRoleItem(params.row)}
                    showInMenu
                  />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={7}
                    icon={<Delete />}
                    label="حذف"
                    onClick={onDeleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
                ...(params.row.isAgent
                  ? []
                  : canSetAsAgent
                  ? [
                      <GridActionsCellItem
                        key={6}
                        icon={<PhoneAndroid />}
                        label="تبدیل به ایجنت"
                        onClick={convertToAgentItem(params.row)}
                        showInMenu
                      />,
                    ]
                  : []),
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useUserTableColumns;
